import { GameContext } from '../../../../contexts/GameContext';
import { ZdarKidsGameStepConfiguration } from '../../../../configuration/games/zdar-kids-game/zdarKidsGameContentConfiguration';
import Button from '../../../common/buttons/Button';
import ContinueButton from '../../../common/buttons/ContinueButton';
import React, { useContext, useState } from 'react';

type TImage = {
    id: number;
};

type Props = {
    onSuccess: () => void;
};
export default function ZdarChurchCipher({ onSuccess }: Props) {
    const { stepContent } = useContext(GameContext);

    const { continueButtonText } = stepContent as ZdarKidsGameStepConfiguration;
    const [solved, setSolved] = useState<TImage[]>([]);

    const correctAnswers = [1, 2, 3, 5];
    const [allAnswers] = useState([
        { name: 'postel', id: 0 },
        { name: 'půdu', id: 1 },
        { name: 'malbu na stěně', id: 2 },
        { name: 'pítko na vodu', id: 3 },
        { name: 'kanón', id: 4 },
        { name: 'sochu dámy, která drží něco zlatého v ruce', id: 5 },
        { name: 'poštovní schránku', id: 6 },
    ]);

    const onClick = (n: number) => {
        if (correctAnswers.find((c) => c === n) && !solved.find((s) => s.id === n)) {
            const newSolved = [];
            newSolved.push(...solved);
            newSolved.push(allAnswers[n]);
            setSolved(newSolved);
        }
    };

    return (
        <React.Fragment>
            <div className="zdar-kids-cipher__bridge">
                <div className="zdar-kids-cipher__bridge__text">
                    Správně {solved.length}/{correctAnswers.length}
                </div>
                {allAnswers && allAnswers.length > 0 && (
                    <div className="zdar-kids-cipher__bridge__names-wrapper">
                        {allAnswers.map((a, i) => {
                            return (
                                <Button
                                    onClick={() => onClick(a.id)}
                                    key={i}
                                    className={
                                        solved.find((s) => s.id === a.id)
                                            ? 'zdar-kids-cipher__bridge__name secondary-button zdar-kids-cipher__bridge__name__solved'
                                            : 'zdar-kids-cipher__bridge__name secondary-button zdar-kids-cipher__bridge__name__unsolved'
                                    }
                                >
                                    {a.name}
                                </Button>
                            );
                        })}
                    </div>
                )}
                {solved.length === correctAnswers.length && (
                    <>
                        <div className="zdar-kids-cipher__bridge__solved">Máte to všechno správně!</div>
                        {continueButtonText && <ContinueButton text={continueButtonText} onClick={onSuccess} />}
                    </>
                )}
            </div>
        </React.Fragment>
    );
}
